/** Parent contract form section. */
import * as React from 'react';
import { FileSignature } from 'lucide-react';
import { DatePicker } from '@/components/forms/DatePicker';
import { FileDropzone } from '@/components/common/FileDropzone';
import { PARENT_CONTRACT_UPLOAD_CONFIG } from '@/components/parents/parent-configs';
import type { ParentFormValues } from '@/types/parent.types';
import {
  defaultParentUpload,
  parentContractDocumentPatch,
} from '@/components/parents/parent-form-utils';

/** Props for {@link ParentContractSection}. */
type Props = Readonly<{
  formData: ParentFormValues;
  onChange: (key: string, value: any) => void;
  onFileSelect?: (key: string, file: File | null) => void;
}>;

/** Parent contract form section. */
export function ParentContractSection({ formData, onChange, onFileSelect }: Props) {
  return (
    <div className="form-section">
      <h4 className="form-section-title">
        <FileSignature className="w-4 h-4" />
        Contrat
      </h4>
      <div className="space-y-4">
        <FileDropzone
          label="Document d'engagement (PDF)"
          required
          value={formData.contractDocumentLink ?? ''}
          onChange={(url) => {
            const patch = parentContractDocumentPatch(url);
            Object.entries(patch).forEach(([key, val]) => onChange(key, val));
          }}
          uploadFn={onFileSelect ? undefined : defaultParentUpload}
          onFileSelect={onFileSelect ? (file) => onFileSelect('contractFile', file) : undefined}
          accept={PARENT_CONTRACT_UPLOAD_CONFIG.accept}
          maxSize={PARENT_CONTRACT_UPLOAD_CONFIG.maxSize}
        />

        <DatePicker
          label="Date de signature"
          value={formData.contractSignedDate ?? ''}
          onChange={(value) => onChange('contractSignedDate', value)}
          inputSize="sm"
          placeholder="JJ/MM/AAAA"
        />
      </div>
    </div>
  );
}
